<template>
  <img src="@/assets/1_b.svg"
       alt="Transportir"
       width="auto"
       height="56">
</template>

<script>
export default {
  name: 'TransportirLogo',
  data () {
    return {};
  },
};
</script>

<style lang="sass"
       scoped>

</style>
